/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePathwayTemplateDto } from '../../models/response-pathway-template-dto';
import { UpdatePathwayTemplateDto } from '../../models/update-pathway-template-dto';

export interface PathwayTemplatesControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Pathway template type
 */
  type: string;
      body: UpdatePathwayTemplateDto
}

export function pathwayTemplatesControllerUpdate(http: HttpClient, rootUrl: string, params: PathwayTemplatesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, pathwayTemplatesControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePathwayTemplateDto>;
    })
  );
}

pathwayTemplatesControllerUpdate.PATH = '/thalea-pathways/pathway-templates/{tenant}/{type}';
